<div *ngIf="usuario?.typ_name == 'PACIENTE'" class="col-md-12">
  <br>
  <div class="minititulo">Mi agenda</div>
  <div class="titulo">Reserva de hora</div>
  <br>
</div>

<app-steps [steps]="steps"></app-steps>


<ng-container *ngIf="infoTransaction && infoTransaction.id_consulta">

  <!-- <div class="col-12 sm-7 text-sm-left container-subtitle-bar">
    <div class="row">
      <div class="col-8 col-md-8 col-sm-7">
        <h3 class="text-select-date">{{ subtitle }}</h3>
      </div>
    </div>
  </div> -->

  <div class="col-12 mt-sm-4 text-sm-left ml-3">
    <div class="row container-success-message p-3">

      <div class="col-12 col-sm-12 text-center mt-3">
        <img src="./assets/images/reserva.png" alt="imagen del medico" class="image-doctor">
      </div>

      <!-- ONDEMAND: muestra mensaje de estado -->
      <div *ngIf="infoTransaction?.ondemand" class="col-12 col-sm-12 text-center mt-3">
        <h3 class="title">{{ msg_status }}</h3>
      </div>
      <div *ngIf="!infoTransaction?.ondemand" class="col-12 col-sm-12 text-center mt-3">
        <h3 class="title">{{ msg_status }}</h3>
      </div>

      <!-- RESERVA NORMAL: muestra número -->
      <div *ngIf="!infoTransaction?.ondemand" class="col-12 col-sm-12 text-center mt-3">
        <h3 class="titleReserva">Nº de reserva: {{ infoTransaction.id_consulta }}</h3>
      </div>

      <div *ngIf="!infoTransaction?.ondemand" class="col-12 col-sm-12 text-center">
        <h3 class="titleReserva">Se ha enviado el detalle de la reserva a tu correo electrónico.</h3>
      </div>

      <!-- ONDEMAND: sub mensaje -->
      <div *ngIf="infoTransaction?.ondemand" class="col-12 col-sm-12 text-center">
        <span style="font-family: 'Mulish'; font-size: 20px; font-weight: normal; color: black;">
          {{ sub_msg_status }}
        </span>
      </div>

      <div class="col-12 col-sm-12 text-center mt-5">

        <!-- Reserva normal -->
        <button
          *ngIf="!infoTransaction?.ondemand && isPaidOk"
          type="button"
          class="btn btn-primary btn-available"
          routerLink="/dashboard">
          Ir al Inicio
        </button>

        <!-- OnDemand -->
        <button
          *ngIf="infoTransaction?.ondemand && isPaidOk"
          type="button"
          class="btn btn-primary btn-available"
          [routerLink]="['/fila-ondemand', infoTransaction.id_consulta, infoTransaction.id_consulta]">
          Ir a la fila de espera
        </button>

      </div>

    </div>
  </div>

</ng-container>
